module.exports = __webpack_public_path__ + "image/human_3_c34f5.png";